"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractiveListItem = exports.InteractiveList = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var react_aria_components_1 = require("react-aria-components");
var theme_1 = require("../../theme");
var StyledList = (0, styled_1.default)(react_aria_components_1.GridList)(function (_a) {
    var hasAction = _a.hasAction;
    return "\n  display: flex;\n  flex-direction: column;\n  gap: ".concat(theme_1.theme.space.space8, ";\n  flex-grow: 1;\n").concat(hasAction &&
        "".concat(exports.InteractiveListItem, " {\n    cursor: default;\n    &[data-hovered] {\n      border-color: ").concat(theme_1.theme.colors.n200, ";\n    }"), "\n");
});
/* eslint-disable @typescript-eslint/ban-types */
var InteractiveList = function (_a) {
    var children = _a.children, onAction = _a.onAction, props = __rest(_a, ["children", "onAction"]);
    var hasAction = onAction ? true : false;
    return (react_1.default.createElement(StyledList, __assign({ hasAction: hasAction, onAction: onAction }, props), children));
};
exports.InteractiveList = InteractiveList;
var backgroundColors = {
    failure: theme_1.theme.colors.red200,
    secondary: theme_1.theme.colors.cg50,
    default: theme_1.theme.colors.surface200,
};
var getBackgroundColor = function (background) {
    return background ? backgroundColors[background] : backgroundColors.default;
};
exports.InteractiveListItem = (0, styled_1.default)(react_aria_components_1.GridListItem)(function (_a) {
    var background = _a.background, onAction = _a.onAction;
    var hasAction = Boolean(onAction);
    return "\n  background: ".concat(getBackgroundColor(background), ";\n  border: var(--border-card);\n  border-radius: ").concat(theme_1.theme.radii.card, ";\n  outline: none;\n  padding: ").concat(theme_1.theme.space.space12, " ").concat(theme_1.theme.space.space16, ";\n\n  &[data-focus-visible] {\n    outline: ").concat(theme_1.theme.borderWidths.thick, " solid ").concat(theme_1.theme.colors.blue400, ";\n    outline-offset: ").concat(theme_1.theme.space.space2, ";\n  }\n\n  ").concat(hasAction &&
        "{\n    cursor: default;\n    &[data-hovered] {\n      border-color: ".concat(theme_1.theme.colors.n200, ";\n    }\n  }"), "\n");
});
//# sourceMappingURL=index.js.map